export default {
	APP_STATUS: {
		INITIALIZING: 1,
		AUTHENTICATING: 2,
		UNAUTHENTICATED: 3,
		READY: 4
	},
	HIDE_OPEN_TRAYS: 'HIDE_OPEN_TRAYS',
	CHANGE_LOADING: 'CHANGE_LOADING',
	REQUEST_AUTHENTICATION: 'REQUEST_AUTHENTICATION',
	REQUEST_AUTHENTICATION_SUCCESS: 'REQUEST_AUTHENTICATION_SUCCESS',
	REQUEST_AUTHENTICATION_FAIL: 'REQUEST_AUTHENTICATION_FAIL',
	REQUEST_SIGN_IN: 'REQUEST_SIGN_IN',
	SELECT_SCHOOL: 'SELECT_SCHOOL',
	CHANGE_SCHEDULE: 'CHANGE_SCHEDULE',
	REQUEST_SCHEDULES: 'REQUEST_SCHEDULES',
	REQUEST_SCHEDULES_SUCCESS: 'REQUEST_SCHEDULES_SUCCESS',
	REQUEST_SCHEDULES_FAIL: 'REQUEST_SCHEDULES_FAIL',
	REQUEST_SCHEDULE: 'REQUEST_SCHEDULE',
	REQUEST_SCHEDULE_SUCCESS: 'REQUEST_SCHEDULE_SUCCESS',
	REQUEST_SCHEDULE_FAIL: 'REQUEST_SCHEDULE_FAIL',
	REQUEST_TEACHERS_SUCCESS: 'REQUEST_TEACHERS_SUCCESS',
	REQUEST_COHORTS_SUCCESS: 'REQUEST_COHORTS_SUCCESS',
	REQUEST_MEETINGS_SUCCESS: 'REQUEST_MEETINGS_SUCCESS',
	REQUEST_SCHEDULED_MEETINGS_SUCCESS: 'REQUEST_SCHEDULED_MEETINGS_SUCCESS',
	SELECT_TEACHER: 'SELECT_TEACHER',
	SELECT_TEACHERS: 'SELECT_TEACHERS',
	SELECT_PARTICIPANTS_GROUP: 'SELECT_PARTICIPANTS_GROUP',
	UNSELECT_TEACHERS: 'UNSELECT_TEACHERS',
	SELECT_COHORT: 'SELECT_COHORT',
	UNSELECT_COHORTS: 'UNSELECT_COHORTS',
	SELECT_CONTROLS_MENU_ITEM: 'SELECT_CONTROLS_MENU_ITEM',
	SELECT_LAYERS_MENU_ITEM: 'SELECT_LAYERS_MENU_ITEM',
	SELECT_TOOLS_MENU_ITEM: 'SELECT_TOOLS_MENU_ITEM',
	SELECT_VIEWER_CELL: 'SELECT_VIEWER_CELL',
	SELECT_VIEWER_COLUMN: 'SELECT_VIEWER_COLUMN',
	SELECT_VIEWER_SUBCOLUMN: 'SELECT_VIEWER_SUBCOLUMN',
	HIDE_VIEWER_COLUMN: 'HIDE_VIEWER_COLUMN',
	UNHIDE_VIEWER_COLUMNS: 'UNHIDE_VIEWER_COLUMNS',
	SELECT_MEETING_LAYER: 'SELECT_MEETING_LAYER',
	SELECT_MEETING_LABEL: 'SELECT_MEETING_LABEL',
	CHANGE_SCHEDULED_MEETING_NAMES: 'CHANGE_SCHEDULED_MEETING_NAMES',
	CHANGE_STUDENT_COHORT_FILTER: 'CHANGE_STUDENT_COHORT_FILTER',
	SHOW_MODAL: 'SHOW_MODAL'
};


/** WEBPACK FOOTER **
 ** ./src/js/constants/index.js
 **/